module.exports = __webpack_public_path__ + "img/b_18.41dec8d4.jpg";